export default "__VITE_PUBLIC_ASSET__f3968005__"